import { FOCUS_WINDOW_CHANGE_FOCUS } from '../../constants/actions';

const onWindowFocusChanged = (focused) => (dispatch) =>
  dispatch({
    type: FOCUS_WINDOW_CHANGE_FOCUS,
    payload: { focused },
  });

export default onWindowFocusChanged;
